import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, TransitionGroup as _TransitionGroup, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "content-container order-content" }
const _hoisted_2 = { class: "serial-numbers-wrapper" }
const _hoisted_3 = { class: "product-name" }
const _hoisted_4 = { class: "input-holder" }
const _hoisted_5 = { class: "user-input" }
const _hoisted_6 = ["value", "onInput"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "icon",
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = {
  key: 2,
  class: "icon",
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_11 = {
  key: 0,
  class: "error-message"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "bar-code-scanner-holder" }
const _hoisted_15 = { class: "bar-code-scanner-overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_base_loader = _resolveComponent("base-loader")!
  const _component_base_panel = _resolveComponent("base-panel")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_stream_barcode_reader = _resolveComponent("stream-barcode-reader")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { class: "page-wrapper" }, {
    default: _withCtx(() => [
      (!_ctx.showBarcodeScanner)
        ? (_openBlock(), _createBlock(_component_ion_header, {
            key: 0,
            class: "ionic-header ion-no-border",
            mode: "ios",
            "no-border": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, {
                class: "toolbar",
                mode: "ios",
                "no-padding": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_back_button, {
                        icon: _ctx.BackIcon,
                        "default-href": "/",
                        text: ""
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("svg", {
                            class: "icon",
                            fill: "none",
                            height: "24",
                            viewBox: "0 0 24 24",
                            width: "24",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z",
                              fill: "black"
                            })
                          ], -1)
                        ]))]),
                        _: 1
                      }, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, { class: "title" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" Serienummers toevoegen ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "ion-content-container"
      }, {
        default: _withCtx(() => [
          _createElementVNode("main", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_TransitionGroup, {
                class: "serial-numbers-wrapper",
                name: "list-complete",
                tag: "div"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderLines, (orderLine, orderLineIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: orderLineIndex }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderLine.quantity, (quantity) => {
                        return (_openBlock(), _createBlock(_component_base_panel, { key: quantity }, {
                          content: _withCtx(() => [
                            _createElementVNode("h6", _hoisted_3, _toDisplayString(orderLine.product.name), 1),
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                (orderLine.product.serial_numbers && !_ctx.order.is_finished)
                                  ? (_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      class: _normalizeClass([{'error': _ctx.checkOrderLineProductConditions(orderLine.product, quantity - 1)}, "serial-input"]),
                                      value: orderLine.product.serial_numbers[quantity - 1],
                                      inputmode: "text",
                                      placeholder: "Serienummer",
                                      type: "text",
                                      onInput: ($event: any) => (_ctx.updateOrderLineSerialNumber($event.target.value, orderLineIndex, quantity - 1))
                                    }, null, 42, _hoisted_6))
                                  : _createCommentVNode("", true),
                                (orderLine.product.serial_numbers && _ctx.order.is_finished)
                                  ? (_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      value: orderLine.product.serial_numbers[quantity - 1],
                                      class: "serial-input",
                                      inputmode: "text",
                                      readonly: "",
                                      type: "text"
                                    }, null, 8, _hoisted_7))
                                  : _createCommentVNode("", true),
                                (orderLine.product.validated_serial_numbers && !_ctx.order.is_finished)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      class: _normalizeClass([[{'valid': orderLine.product.validated_serial_numbers[quantity - 1] &&
                                                                 orderLine.product.validated_serial_numbers[quantity - 1].isValid === true},
                                                             {'loading': orderLine.product.validated_serial_numbers[quantity - 1] &&
                                                                 orderLine.product.validated_serial_numbers[quantity - 1].loading === true}], "btn-circular barcode-button"]),
                                      onClick: ($event: any) => (_ctx.openBarcodeScanner(orderLineIndex, quantity - 1))
                                    }, [
                                      _createVNode(_Transition, {
                                        mode: "out-in",
                                        name: "rotate-fade"
                                      }, {
                                        default: _withCtx(() => [
                                          (orderLine.product.validated_serial_numbers &&
                                                             orderLine.product.validated_serial_numbers[quantity - 1] &&
                                                             orderLine.product.validated_serial_numbers[quantity - 1].isValid === true &&
                                                             orderLine.product.validated_serial_numbers[quantity - 1].loading === false)
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[4] || (_cache[4] = [
                                                _createElementVNode("path", {
                                                  "clip-rule": "evenodd",
                                                  d: "M19.729 7.80303C19.9097 7.9798 20 8.19444 20 8.44697C20 8.6995 19.9097 8.91414 19.729 9.09091L11.4065 17.2348C11.2258 17.4116 11.0065 17.5 10.7484 17.5C10.4903 17.5 10.271 17.4116 10.0903 17.2348L5.27097 12.5189C5.09032 12.3422 5 12.1275 5 11.875C5 11.6225 5.09032 11.4078 5.27097 11.2311L6.5871 9.94318C6.76774 9.76641 6.9871 9.67803 7.24516 9.67803C7.50323 9.67803 7.72258 9.76641 7.90323 9.94318L10.7484 12.7367L17.0968 6.51515C17.2774 6.33838 17.4968 6.25 17.7548 6.25C18.0129 6.25 18.2323 6.33838 18.4129 6.51515L19.729 7.80303Z",
                                                  fill: "white",
                                                  "fill-rule": "evenodd"
                                                }, null, -1)
                                              ]))]))
                                            : (orderLine.product.validated_serial_numbers[quantity - 1] &&
                                                                     orderLine.product.validated_serial_numbers[quantity - 1].loading === true)
                                              ? (_openBlock(), _createBlock(_component_base_loader, {
                                                  key: 1,
                                                  type: 'small'
                                                }))
                                              : (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[5] || (_cache[5] = [
                                                  _createElementVNode("path", {
                                                    d: "M18.5625 18.5774L20.75 18.5623V5.43732L18.5625 5.45236",
                                                    stroke: "#D98240",
                                                    "stroke-linecap": "square",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "1.45833"
                                                  }, null, -1),
                                                  _createElementVNode("path", {
                                                    d: "M5.43746 5.43732L3.24996 5.45236V18.5774L5.43746 18.5623",
                                                    stroke: "#D98240",
                                                    "stroke-linecap": "square",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "1.45833"
                                                  }, null, -1),
                                                  _createElementVNode("path", {
                                                    d: "M17.8333 9.08313V14.9165",
                                                    stroke: "#D98240",
                                                    "stroke-linecap": "square",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "1.45833"
                                                  }, null, -1),
                                                  _createElementVNode("path", {
                                                    d: "M14.9166 7.62482V16.3748",
                                                    stroke: "#D98240",
                                                    "stroke-linecap": "square",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "1.45833"
                                                  }, null, -1),
                                                  _createElementVNode("path", {
                                                    d: "M12 8.354V15.6457",
                                                    stroke: "#D98240",
                                                    "stroke-linecap": "square",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "1.45833"
                                                  }, null, -1),
                                                  _createElementVNode("path", {
                                                    d: "M9.0833 7.62482V16.3748",
                                                    stroke: "#D98240",
                                                    "stroke-linecap": "square",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "1.45833"
                                                  }, null, -1),
                                                  _createElementVNode("path", {
                                                    d: "M6.16663 9.08313V14.9165",
                                                    stroke: "#D98240",
                                                    "stroke-linecap": "square",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "1.45833"
                                                  }, null, -1)
                                                ]))]))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ], 10, _hoisted_8))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(_Transition, {
                                mode: "out-in",
                                name: "fade"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.checkOrderLineProductConditions(orderLine.product, quantity - 1))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(orderLine.product.validated_serial_numbers[quantity - 1].message), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ], 64))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            (!_ctx.order.is_finished)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn full-width ion-activatable ripple-parent",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toNextStep && _ctx.toNextStep(...args)))
                }, [
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (!_ctx.isUpdating)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Volgende stap"))
                        : (_openBlock(), _createBlock(_component_base_loader, { key: 1 }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_ripple_effect)
                ]))
              : _createCommentVNode("", true),
            (_ctx.order.is_finished)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn full-width ion-activatable ripple-parent",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toNextStepFinished && _ctx.toNextStepFinished(...args)))
                }, [
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (!_ctx.isUpdating)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Volgende stap"))
                        : (_openBlock(), _createBlock(_component_base_loader, { key: 1 }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_ripple_effect)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "aim-on-barcode" }, [
                    _createElementVNode("svg", {
                      class: "icon",
                      fill: "none",
                      viewBox: "0 0 25 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        "clip-rule": "evenodd",
                        d: "M0.5 8V2.66667C0.5 1.2 1.7 0 3.16667 0H8.5V2.66667H3.16667V8H0.5ZM0.5 16H3.16667V21.3333H8.5V24H3.16667C1.7 24 0.5 22.8 0.5 21.3333V16ZM21.8333 21.3333H16.5V24H21.8333C23.3 24 24.5 22.8 24.5 21.3333V16H21.8333V21.3333ZM16.5 0H21.8333C23.3 0 24.5 1.2 24.5 2.66667V8H21.8333V2.66667H16.5V0Z",
                        fill: "white",
                        "fill-rule": "evenodd"
                      })
                    ]),
                    _createElementVNode("h3", null, "Richt op de barcode")
                  ], -1)),
                  _createVNode(_component_ion_button, {
                    class: "btn-circular close-scanner",
                    onClick: _ctx.closeBarcodeScanner
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("svg", {
                        class: "icon",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M23.2003 3.05629L20.9443 0.800293L12.0003 9.74429L3.05629 0.800293L0.800293 3.05629L9.74429 12.0003L0.800293 20.9443L3.05629 23.2003L12.0003 14.2563L20.9443 23.2003L23.2003 20.9443L14.2563 12.0003L23.2003 3.05629Z",
                          fill: "white"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createVNode(_Transition, {
                  mode: "out-in",
                  name: "fade"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.barcodeScannerLoaded)
                      ? (_openBlock(), _createBlock(_component_base_loader, {
                          key: 0,
                          type: "medium"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.showBarcodeScanner)
                  ? (_openBlock(), _createBlock(_component_stream_barcode_reader, {
                      key: 0,
                      class: "bar-code-scanner",
                      onDecode: _ctx.onDecode,
                      onLoaded: _ctx.onLoaded
                    }, null, 8, ["onDecode", "onLoaded"]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, _ctx.showBarcodeScanner]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}